import React, { useState } from "react";
import { Tabs, Tab, Paper } from "../../components";
import Timeline from "./Timeline";
import TaskList from "./TaskList";
import WorkflowGraph from "../../components/diagram/WorkflowGraph";
import { makeStyles } from "@material-ui/styles";
import { useDevicePixelRatio } from "use-device-pixel-ratio";
const useStyles = makeStyles({
  taskWrapper: {
    // overflowY: "auto",
    padding: 8,
    height: "100%",
  },
  fullHeight: {
    height: "100%",
  },
});

export default function TaskDetails({
  execution,
  dag,
  selectedTask,
  setSelectedTask,
  showOnlyDiagram,
  refresh,
  rightDrawerWidth,
  isFetching,
  deselectTaskAndCloseRightPanel,
}) {
  const [tabIndex, setTabIndex] = useState(0);
  const classes = useStyles();
  const [svgLoading, setSvgLoading] = useState(true);

  const dpr = useDevicePixelRatio({ defaultDpr: 1 });
  return (
    <div className={classes.taskWrapper}>
      <Paper className={classes.fullHeight}>
        {/*show tabs only for normal view i.e., if showOnlyDiagram false */}
        {!showOnlyDiagram && (
          <Tabs value={tabIndex} contextual id="exe-subheader">
            <Tab label="Diagram" onClick={() => setTabIndex(0)} />
            <Tab label="Task List" onClick={() => setTabIndex(1)} />
            <Tab label="Timeline" onClick={() => setTabIndex(2)} />
          </Tabs>
        )}

        {(tabIndex === 0 || showOnlyDiagram) && (
          <WorkflowGraph
            selectedTask={selectedTask}
            executionMode={true}
            dag={dag}
            onClick={setSelectedTask}
            showOnlyDiagram={showOnlyDiagram}
            refresh={refresh}
            rightDrawerWidth={rightDrawerWidth}
            componentLoadedFrom={"Execution"}
            svgLoading={svgLoading}
            setSvgLoading={setSvgLoading}
            isFetching={isFetching}
            dpr={dpr}
            deselectTaskAndCloseRightPanel={() =>
              deselectTaskAndCloseRightPanel()
            }
          />
        )}
        {tabIndex === 1 && (
          <TaskList
            workflowId={execution.workflowId}
            selectedTask={selectedTask}
            tasks={execution.tasks}
            dag={dag}
            onClick={setSelectedTask}
          />
        )}
        {tabIndex === 2 && (
          <Timeline
            selectedTask={selectedTask}
            tasks={execution.tasks}
            dag={dag}
            onClick={setSelectedTask}
          />
        )}
      </Paper>
    </div>
  );
}
